import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthStateService } from './auth-state-service';
import { AuthGuard } from './auth.guard';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate, CanActivateChild {
  private readonly _router = inject(Router);
  private readonly _authState = inject(AuthStateService);
  private readonly _authGuard = inject(AuthGuard);

  /** Restricts the administration workspace after AuthGuard initializes the claims. */
  canActivate(): boolean | UrlTree {
    return this._authState.hasAdminRole() ? true : this._router.parseUrl('/m');
  }

  /** Rechecks refreshed claims when navigating between administration modules. */
  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // Ancestor child guards run concurrently, so explicitly await authentication here.
    return this._authGuard
      .canActivate(next, state)
      .pipe(map((isAuthenticated: boolean): boolean | UrlTree => (isAuthenticated ? this.canActivate() : false)));
  }
}
